<template>
  <PersonalAreaTemplate :editing="editing" :max-width="modal ? null : 888">
    <v-form class="d-grid gap-5" ref="form" v-model="valid" lazy-validation>
      <BaseInput
        :label="label"
        :placeholder="label"
        :view="!editing"
        v-model="externalIdData"
      />
    </v-form>
  </PersonalAreaTemplate>
</template>

<script>
import { mapActions } from 'vuex'
import PersonalAreaTemplate from 'components/personalArea/personalAreaTemplate'

export default {
  name: 'ExternalId',
  props: {
    editing: Boolean,
    externalId: [String, Number],
    modal: Boolean,
  },
  components: { PersonalAreaTemplate },
  data: () => ({
    valid: false,
    externalIdData: '',
  }),
  computed: {
    label() {
      return (
        this.localStorage?.translations?.pages?.common?.text?.worker_id ||
        'Worker ID'
      )
    },
  },
  watch: {
    externalId() {
      this.onActualData()
    },
    externalIdData() {
      this.onNavigationGuardianCheck({
        data: { externalIdData: this.externalIdData },
        overwrite: false,
      })
    },
  },
  mounted() {
    this.onActualData()
  },
  methods: {
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    validate() {
      return this.$refs.form ? this.$refs.form.validate() : true
    },
    onActualData() {
      this.externalIdData = this.externalId ?? ''
      this.onNavigationGuardianCheck({
        data: { externalIdData: this.externalIdData },
        overwrite: true,
      })
    },
    async saveChange() {
      return new Promise((resolve, reject) => {
        if (!this.validate()) return reject(false)
        if (this.$checkNavigationGuardianChange('externalIdData')) {
          resolve({ external_id: this.externalIdData })
        } else resolve(true)
      })
    },
  },
}
</script>
